export const MENU = {
  AUTH: "isAuthMenuOpen",
  OPEN: "isMenuOpen",
  MINI: "isMiniMode",
  MOBILE_OPEN: "isMobileMenuOpen",
  MINI_SWITCH_VISIBLE: "isMiniSwitchVisibility",
} as const;

export type MenuStateKeys = (typeof MENU)[keyof typeof MENU];

export interface MenuState {
  isAuthMenuOpen: boolean;
  isMiniMode: boolean;
  isMenuOpen: boolean;
  isMobileMenuOpen: boolean;
  isMiniSwitchVisibility: boolean;
}

export interface MenuContextValue {
  state: MenuState;
  toggleThis: <K extends MenuStateKeys>(key: K, value?: boolean) => void;
  setMany: (patch: Partial<MenuState>) => void;

  open: () => void;
  close: () => void;

  setAuthMenuOpen: (open: boolean) => void;
  setMiniMode: (mini: boolean) => void;
  setMenuOpen: (open: boolean) => void;
  setMobileMenuOpen: (open: boolean) => void;
  setMiniSwitchVisibility: (visible: boolean) => void;
  openMenu: () => void;
  closeMenu: () => void;
  toggleMenuOpen: () => void;

  collapseMenu: () => void;
  expandMenu: () => void;
  toggleMiniMode: () => void;
}
